import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchProductGroupById(id) {
  const { data } = await http(`/admin/product-groups/${id}`);

  return data;
}

export function useProductGroupById(id) {
  const { data, ...raResult } = useQuery(["product-groups", id], () =>
    fetchProductGroupById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
